/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ExecutionSource = typeof ExecutionSource[keyof typeof ExecutionSource];


export const ExecutionSource = {
  api: 'api',
  admin_api: 'admin_api',
  publisher_api: 'publisher_api',
  worker: 'worker',
  system: 'system',
} as const;
